import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministradordemonitoreoRoutingModule } from './administradordemonitoreos-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// Material Modules
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';

// Feature Modules - Estos los agregaremos después cuando creemos los submódulos
// import { SubmoduloEjemploModule } from './modules/submodulo-ejemplo/submodulo-ejemplo.module';

const materialModules = [
  MatTableModule,
  MatPaginatorModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatSelectModule,
  MatCheckboxModule,
  MatAutocompleteModule,
  MatIconModule,
  MatSnackBarModule,
  MatCardModule,
  MatProgressSpinnerModule,
  MatSortModule
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AdministradordemonitoreoRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ...materialModules,
    // Aquí importaremos los submódulos cuando los creemos
  ]
})
export class AdministradordemonitoreoModule { }